export default __webpack_public_path__ + "static/media/imedicina-negative.df64f41f.svg";